import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { apiOrNull, MARKETPLACE, marketplaceKeys } from './client';
import type { ReviewsPage } from './contracts';

/**
 * `GET /salon/{s}/reviews?page&size` (§8). `null` while the backend doesn't
 * have reviews yet — the UI then shows the "New" state, never a fake score.
 */
export function useSalonReviews(
  subdomain: string | undefined,
  opts: { page?: number; size?: number; enabled?: boolean } = {},
) {
  const page = opts.page ?? 0;
  const size = opts.size ?? 10;
  return useQuery<ReviewsPage | null>({
    queryKey: marketplaceKeys.salonReviews(subdomain, page, size),
    enabled: !!subdomain && (opts.enabled ?? true),
    queryFn: () =>
      apiOrNull<ReviewsPage>(
        `${MARKETPLACE}/salon/${subdomain}/reviews?page=${page}&size=${size}`,
      ),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
